import { useState } from 'react'
import styles from '../../styles/admin/StudyContent.module.scss'
import CorrectAnswerMultiple from '../common/CorrectAnswerMultiple'
import ExplanationSection from '../common/ExplanationSection'
import ImageDropzone from '../common/ImageDropzone'
import QuestionInput from '../common/QuestionInput'

const QuizTypeC = ({
  question,
  questionImageFile,
  correctAnswers,
  checkedStates,
  explanation,
  explanationImageFile,
  className,
  onQuestionChange,
  onQuestionImageChange,
  onCorrectAnswersChange,
  onCheckedStatesChange,
  onExplanationChange,
  onExplanationImageChange,
  existingQuestionImageUrl,
  existingExplanationImageUrl,
  onExistingQuestionImageRemove,
  onExistingExplanationImageRemove,
}) => {
  return (
    <div className={`${styles.quizTypeCContainer} ${className || ''}`}>
      <div className={styles.quizTypeCWrapper}>
        <QuestionInput
          value={question}
          onChange={onQuestionChange}
          className={styles.quizTypeCQuestion}
        />

        <div className={styles.quizTypeCFlexWrapper}>
          <ImageDropzone
            imageFile={questionImageFile}
            onImageChange={onQuestionImageChange}
            existingImageUrl={existingQuestionImageUrl}
            className={styles.quizTypeCImage}
            onExistingImageRemove={onExistingQuestionImageRemove}
          />

          <CorrectAnswerMultiple
            values={correctAnswers}
            onValuesChange={onCorrectAnswersChange}
            checkedStates={checkedStates}
            onCheckedStatesChange={onCheckedStatesChange}
            label="Answer (5entries)"
            className={styles.quizTypeCAnswer}
          />
        </div>

        <ExplanationSection
          explanation={explanation}
          onExplanationChange={onExplanationChange}
          explanationImageFile={explanationImageFile}
          existingImageUrl={existingExplanationImageUrl}
          onExplanationImageChange={onExplanationImageChange}
          onExistingImageRemove={onExistingExplanationImageRemove}
          className={styles.quizTypeCExplanation}
        />
      </div>
    </div>
  )
}

export default QuizTypeC
